export default __webpack_public_path__ + "images/bc6867cf882bac98e3a3cb4b6b46a91e-community.png";